import Honeybadger from '@honeybadger-io/js';
import extendSession from '../../packs/logged_in_user/extendSession';

const DATA_TYPE_MAPPING = {
  json: { dataType: 'json' },
  string_json: { dataType: 'json', contentType: 'application/json' },
  form_data: { dataType: 'json', processData: false, contentType: false },
  zip: {
    dataType: 'json', headers: { 'Content-Type': 'application/zip', acl: 'authenticated-read' }, processData: false, contentType: false
  },
  jsonp: { dataType: 'jsonp' },
  html: { dataType: 'html' }
};

/* eslint-disable juno-custom-rules/no-jquery-ajax */
// This is the only place where we use jQuery ajax methods

export default class ServerRequest {
  constructor(url, dataType) {
    this.url = url;
    this.dataTypeOptions = DATA_TYPE_MAPPING[dataType];
    this.honeybadger = Honeybadger.configure({
      api_key: gon.honeybadger_api_key,
      environment: 'production',
      revision: 'master',
      max_depth: 2
    });
  }

  makeRequest(type, data, includeCsrfToken = true) {
    const { skipCsrfTokenRefresh = false } = data || {};
    const options = {
      type,
      url: this.url,
      data,
      ...this.dataTypeOptions
    };

    if (includeCsrfToken) {
      options.beforeSend = function (request) {
        const csrfToken = document.querySelector('meta[name=csrf-token]')?.content;
        if (csrfToken) {
          request.setRequestHeader('X-CSRF-Token', csrfToken);
        }
      };
    }
    const sessionExpiresAt = localStorage.getItem('session_expires_at');
    const timeRemaining = parseInt(sessionExpiresAt) - Math.floor(Date.now() / 1000);

    // If session is not expired, or CSRF token is not required, make the request
    if (timeRemaining >= 0 || !includeCsrfToken || skipCsrfTokenRefresh) {
      return $.ajax(options);
    }

    // Session is expired, try to extend it, and then make the request
    const deferred = $.Deferred();

    this.honeybadger.notify('Extend Session popup bypassed; Attempting to extend session before making request', {
      context: {
        url: this.url,
        type: type,
        timeRemaining: timeRemaining
      }
    });

    fetch('/up_authenticated')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Authentication check failed');
        }
        extendSession(response);
        return $.ajax(options);
      })
      .then((result) => deferred.resolve(result))
      .catch((error) => deferred.reject(error));

    return deferred.promise();
  }

  get(data) {
    return this.makeRequest('GET', data, false);
  }

  post(data) {
    return this.makeRequest('POST', data);
  }

  put(data) {
    return this.makeRequest('PUT', data, true);
  }

  patch(data) {
    return this.makeRequest('PATCH', data, true);
  }

  delete(data) {
    return this.makeRequest('DELETE', data, true);
  }
}

/* eslint-enable juno-custom-rules/no-jquery-ajax */
